// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"QBqiO6CG","checkboxBox":"_3pc_oRF_","checkboxIcon":"_2fTiy12t","fullWidth":"_1zQEODbX","checkboxLabel":"_367HHZdo"};